/**
 * Do not retry authz/authn failures — retries cause 403 storms on gated pages.
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (typeof error === 'object' && error !== null && 'status' in error) {
    const status = (error as { status?: number }).status;
    if (status === 401 || status === 403) {
      return false;
    }
  }
  return failureCount < 1;
}
